import { Api } from './api'
import { env } from '@lib/env'

export class TablelistProApi<T> extends Api<T> {
  basePath: string

  constructor(basePath: string) {
    super(env.tablelistApiUrl, {
      apiKey: env.tablelistApiKey,
      pathPrefix: basePath,
    })
    this.basePath = basePath
  }
}
